<!--=================================
banner -->
<app-menu headerCSS="header-transparent"></app-menu>
<section class="header-inner header-inner-big bg-holder text-white"
  style="background-image: url(assets/images/bg/banner-01.jpg);">
  <candidate-filter></candidate-filter>
</section>
<!--=================================
  banner -->

<!--=================================
  candidate post-box list -->
<section class="space-ptb">
  <div class="container">
    <div class="row">
      <div class="col-lg-3">
        <div class="sidebar">
          <div class="widget">
            <div class="widget-title widget-collapse">
              <h6>Date Posted</h6>
              <a class="ml-auto" data-toggle="collapse" href="#dateposted" role="button" aria-expanded="false"
                aria-controls="dateposted"> <i class="fas fa-chevron-down"></i> </a>
            </div>
            <div class="collapse show" id="dateposted">
              <div class="widget-content">
                <div class="custom-control custom-checkbox">
                  <input #dateposted type="checkbox" class="custom-control-input"
                    (click)="onDatePostedPeriodClicked($event, 0)" id="dateposted-0">
                  <label class="custom-control-label" for="dateposted-0">Last 24 hour</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input #dateposted type="checkbox" class="custom-control-input"
                    (click)="onDatePostedPeriodClicked($event, 3)" id="dateposted-3">
                  <label class="custom-control-label" for="dateposted-3">Last 3 days</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input #dateposted type="checkbox" class="custom-control-input"
                    (click)="onDatePostedPeriodClicked($event, 7)" id="dateposted-7">
                  <label class="custom-control-label" for="dateposted-7">Last 7 days</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input #dateposted type="checkbox" class="custom-control-input"
                    (click)="onDatePostedPeriodClicked($event, 14)" id="dateposted-14">
                  <label class="custom-control-label" for="dateposted-14">Last 14 days</label>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="widget">
            <div class="widget-title widget-collapse">
              <h6>Experience</h6>
              <a class="ml-auto" data-toggle="collapse" href="#experience" role="button" aria-expanded="false"
                aria-controls="experience"> <i class="fas fa-chevron-down"></i> </a>
            </div>
            <div class="collapse show" id="experience">
              <div class="widget-content">
                <div class="custom-control custom-checkbox">
                  <input #experience type="checkbox" class="custom-control-input" id="experience-1"
                    (click)="onExperienceClicked($event,1)">
                  <label class="custom-control-label" for="experience-1">at least 1 Year</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input #experience type="checkbox" class="custom-control-input" id="experience-2"
                    (click)="onExperienceClicked($event,2)">
                  <label class="custom-control-label" for="experience-2">at least 2 Year</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input #experience type="checkbox" class="custom-control-input" id="experience-3"
                    (click)="onExperienceClicked($event,3)">
                  <label class="custom-control-label" for="experience-3">at least 3 Year</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input #experience type="checkbox" class="custom-control-input" id="experience-4"
                    (click)="onExperienceClicked($event,4)">
                  <label class="custom-control-label" for="experience-4">at least 4 Year</label>
                </div>
                <div class="custom-control custom-checkbox">
                  <input #experience type="checkbox" class="custom-control-input" id="experience-5"
                    (click)="onExperienceClicked($event,5)">
                  <label class="custom-control-label" for="experience-5">at least 5 Year</label>
                </div>
              </div>
            </div>
            <hr>
            <div class="widget">
              <div class="widget-title widget-collapse">
                <h6>Qualification</h6>
                <a class="ml-auto" data-toggle="collapse" href="#qualification" role="button" aria-expanded="false"
                  aria-controls="qualification"> <i class="fas fa-chevron-down"></i></a>
              </div>
              <div class="collapse show" id="qualification">
                <div class="widget-content">
                  <div class="custom-control custom-checkbox"
                    *ngFor="let educationLevel of (lookupStore.educationLevels | async)">
                    <input #qualification type="checkbox" class="custom-control-input"
                      (click)="onEducationLevelClicked($event, educationLevel.id)"
                      id="educationLevel-{{educationLevel.id}}">
                    <label class="custom-control-label"
                      for="educationLevel-{{educationLevel.id}}">{{educationLevel.value}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-9">
        <!--=================================
                      right-sidebar -->
        <div class="job-filter mb-4 d-sm-flex align-items-center">
          <div class="job-shortby ml-sm-auto d-flex align-items-center">
            <form class="form-inline">
              <div class="form-group mb-0">
                <label class="justify-content-start mr-2">sort by :</label>
                <div class="short-by">
                  <select class="form-control basic-select" (change)="onSortOrderChanged($event)">
                    <option value="0">Recent</option>
                    <option value="1">Oldest</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
        <candidates-list [candidates]="candidates" [totalPageCount]="totalPageCount" [showSalary]="false" [showBookmark]="true"></candidates-list>
        <div class="row">
          <pager [totalPageCount]="totalPageCount" (valueChange)="onPagerValueChanged($event)"></pager>
        </div>
      </div>
    </div>
  </div>
</section>